export default __webpack_public_path__ + "65d869552215e4f9ac90841d526d2d8b.png";